module.exports = __webpack_public_path__ + "img/index_part1bg.0966f83c.png";